<template>
  <div class="api-demo">
    <h2>API请求演示</h2>
    <div class="demo-section">
      <h3>GET请求示例 (自动添加languageType: 1)</h3>
      <button @click="fetchData">获取数据</button>
      <div v-if="loading" class="loading">加载中...</div>
      <pre v-if="data">{{ JSON.stringify(data, null, 2) }}</pre>
    </div>
    
    <div class="demo-section">
      <h3>POST请求示例 (自动添加languageType: 1到请求体)</h3>
      <input v-model="newData.title" placeholder="输入标题" />
      <input v-model="newData.content" placeholder="输入内容" />
      <button @click="submitData">提交数据</button>
    </div>
    
    <div class="demo-section">
      <h3>语言类型切换</h3>
      <select v-model="languageType" @change="updateLanguageType">
        <option value="1">中文</option>
        <option value="2">English</option>
        <option value="3">Bahasa Malaysia</option>
        <option value="4">Bahasa indonesia</option>
      </select>
    </div>
  </div>
</template>

<script setup>
import { ref } from 'vue';
import { getData, postData } from '@/api';

const data = ref(null);
const loading = ref(false);
const languageType = ref('1');
const newData = ref({
  title: '',
  content: ''
});

const fetchData = async () => {
  loading.value = true;
  try {
    // 使用封装的API方法，GET请求会自动添加languageType: 1
    const result = await getData({ page: 1, limit: 10 });
    data.value = result;
  } catch (error) {
    console.error('获取数据失败:', error);
  } finally {
    loading.value = false;
  }
};

const submitData = async () => {
  try {
    // POST请求会自动在请求体中添加languageType: 1
    const result = await postData(newData.value);
    console.log('提交成功:', result);
    // 清空表单
    newData.value = { title: '', content: '' };
    // 可以选择重新获取数据
    fetchData();
  } catch (error) {
    console.error('提交数据失败:', error);
  }
};

const updateLanguageType = () => {
  // 更新localStorage中的语言类型，这样全局请求拦截器可以使用它
  localStorage.setItem('languageType', languageType.value);
  console.log(`语言类型已更新为: ${languageType.value}`);
};

// 初始化语言类型
updateLanguageType();
</script>

<style scoped>
.api-demo {
  padding: 20px;
  max-width: 800px;
  margin: 0 auto;
}

.demo-section {
  margin-bottom: 30px;
  padding: 20px;
  border: 1px solid #ddd;
  border-radius: 4px;
}

.loading {
  color: #666;
  font-style: italic;
}

pre {
  background-color: #f5f5f5;
  padding: 10px;
  border-radius: 4px;
  overflow-x: auto;
}

input {
  display: block;
  width: 100%;
  padding: 8px;
  margin: 5px 0 10px;
  border: 1px solid #ddd;
  border-radius: 4px;
}

button {
  padding: 8px 16px;
  background-color: #007bff;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}

button:hover {
  background-color: #0056b3;
}
</style>